import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

export const getTours = () => api.get("/tours").then((r) => r.data);
export const getTour = (slug) => api.get(`/tours/${slug}`).then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const getFAQs = () => api.get("/faqs").then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const createContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const createCheckout = (bookingId) =>
  api.post("/payments/checkout", { booking_id: bookingId, origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// ---- Admin (shared team access key stored in sessionStorage) ----
const adminHeaders = () => ({ headers: { "X-Admin-Key": sessionStorage.getItem("hc_admin_key") || "" } });
export const checkAdminKey = (key) => api.get("/admin/check", { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const getBookings = () => api.get("/bookings", adminHeaders()).then((r) => r.data);
export const updateBookingStatus = (id, status) => api.patch(`/bookings/${id}/status`, { status }, adminHeaders()).then((r) => r.data);
export const updateBooking = (id, payload) => api.patch(`/bookings/${id}`, payload, adminHeaders()).then((r) => r.data);
export const addBookingPayment = (id, payload) => api.post(`/bookings/${id}/payments`, payload, adminHeaders()).then((r) => r.data);
export const deleteBooking = (id) => api.delete(`/bookings/${id}`, adminHeaders()).then((r) => r.data);
export const getAdminStats = () => api.get("/admin/stats", adminHeaders()).then((r) => r.data);
export const getAdminClients = () => api.get("/admin/clients", adminHeaders()).then((r) => r.data);
export const getAdminPayments = () => api.get("/admin/payments", adminHeaders()).then((r) => r.data);
export const getTeam = () => api.get("/admin/team", adminHeaders()).then((r) => r.data);
export const addTeamMember = (payload) => api.post("/admin/team", payload, adminHeaders()).then((r) => r.data);
export const deleteTeamMember = (id) => api.delete(`/admin/team/${id}`, adminHeaders()).then((r) => r.data);
